import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {flowRight as compose} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {COLORS} from '../constants';
import {withTheme} from './HOC/withTheme';
import Image from './Image';

const MenuItem = ({t, route, active, theme}) => {
  const {icon, image, name, to} = route;
  const imageStyle = {
    height: 20,
    backgroundColor: active ? COLORS.MAIN_PINK : COLORS.WHITE,
  };
  const {sidebar} = theme;

  return (
    <div style={{background: active ? sidebar.activeItem : COLORS.TRANSPARENT}}>
      <Link className="nav-link" to={to}>
        {icon && (
          <FontAwesomeIcon icon={icon} color={active ? sidebar.activeColor : COLORS.WHITE} />
        )}
        {image && <Image alt={'tickets'} src={image} style={imageStyle} />}
        <span className="route-name">{t('sidebar.' + name)}</span>
      </Link>
    </div>
  );
};

MenuItem.propTypes = {
  t: PropTypes.func.isRequired,
  route: PropTypes.shape({
    name: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
    icon: PropTypes.object,
    image: PropTypes.string,
  }).isRequired,
  active: PropTypes.bool,
  theme: PropTypes.shape({
    sidebar: PropTypes.shape({
      activeColor: PropTypes.string.isRequired,
      activeItem: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default compose(
  withTranslation('common'),
  withTheme,
)(MenuItem);
